(function ($, bootstrap) {
  'use strict';

  if (!$ || !bootstrap) {
    throw new Error('Bootstrap 5 compatibility layer requires jQuery and Bootstrap.');
  }

  var dataApiValues = {
    alert: true,
    button: true,
    carousel: true,
    collapse: true,
    dropdown: true,
    modal: true,
    offcanvas: true,
    pill: true,
    popover: true,
    scrollspy: true,
    tab: true,
    toast: true,
    tooltip: true
  };

  function migrateDataAttributes(root) {
    $(root).find('[data-toggle], [data-target], [data-dismiss], [data-ride], [data-spy], [data-offset]').addBack().each(function () {
      var $element = $(this);
      var toggle = $element.attr('data-toggle');

      if (toggle && dataApiValues[toggle]) {
        $element.attr('data-bs-toggle', toggle);
      }

      ['target', 'dismiss', 'ride', 'spy', 'offset'].forEach(function (name) {
        var value = $element.attr('data-' + name);
        if (value !== undefined) {
          $element.attr('data-bs-' + name, value);
        }
      });
    });
  }

  function installJQueryPlugin(name, Component) {
    $.fn[name] = function (config) {
      var args = Array.prototype.slice.call(arguments, 1);

      return this.each(function () {
        var instance = Component.getOrCreateInstance(this, typeof config === 'object' ? config : undefined);
        if (typeof config === 'string') {
          if (typeof instance[config] !== 'function') {
            throw new TypeError('Bootstrap component "' + name + '" has no method "' + config + '".');
          }
          instance[config].apply(instance, args);
        }
      });
    };
    $.fn[name].Constructor = Component;
  }

  migrateDataAttributes(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          migrateDataAttributes(node);
        }
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  installJQueryPlugin('button', bootstrap.Button);
  installJQueryPlugin('collapse', bootstrap.Collapse);
  installJQueryPlugin('dropdown', bootstrap.Dropdown);
  installJQueryPlugin('modal', bootstrap.Modal);
  installJQueryPlugin('popover', bootstrap.Popover);
  installJQueryPlugin('toast', bootstrap.Toast);
  installJQueryPlugin('tooltip', bootstrap.Tooltip);
}(jQuery, bootstrap));
